import { PUBLIC_URL } from '../../utils/constants';

export default {
  LOCATION_LISTING: `${PUBLIC_URL}/location/list`,
  ADD_LOCATION: `${PUBLIC_URL}/location/add`,
  EDIT_LOCATION: `${PUBLIC_URL}/location/edit/:id`,
};
